import api from '@/api/users';
import store from '@/store';
import { fromShortToLong } from '@/components/shared/languageCodes';
import VueCookies from 'vue-cookies';
import Vue from 'vue';
import CONSTANTS from '@/constants';
import EventBus from '@/components/shared/eventbus';

Vue.use(VueCookies);

const redeemCoupon = (context, coupon_code) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .redeemCoupon(apiLevel, coupon_code)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const handleProfileResponse = (
  context,
  response,
  initialUserProfileRequest = false,
) => {
  // let initialUserProfileRequest = false;
  // if (payload) {
  //   initialUserProfileRequest = payload.initialUserProfileRequest;
  // }

  // if (scopes.includes('user')) {
  if (response.user) {
    if (
      !window.$cookies.get('x-token') ||
      window.$cookies.get('x-token') == '' ||
      window.$cookies.get('x-token') == 'undefined' ||
      window.$cookies.get('x-token') == 'null'
    ) {
      window.$cookies.set(
        'x-token',
        response.user.token,
        null,
        null,
        '.xeropan.com',
      );
    }
    if (!initialUserProfileRequest) {
      context.commit(
        'settings/SET_USER_SELECTED_LANGUAGE',
        fromShortToLong[response.user.languageCode],
        { root: true },
      );
    }
    context.commit(
      'settings/SET_SELECTED_LEARNED_LANGUAGE',
      response.user.learnedLanguageCode,
      { root: true },
    );
    context.commit('sales/SET_SALES_FLOW', response.user.state.promotion, {
      root: true,
    });
    // if (response.user.currentIsland != undefined) {
    //   const currLevel = response.user.currentIsland;
    //   const islandData = {
    //     level: currLevel,
    //     island: `island_${currLevel}`,
    //   };
    //   // context.commit('contents/CURRENTLY_LOADED_ISLAND', islandData, {
    //   //   root: true,
    //   // });
    // }
  }
  context.commit('SET_USER_PROFILE', { profile: response });
};

const getUserProfile = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    const data = payload || {};
    if (data.initialUserProfileRequest) {
      delete data.initialUserProfileRequest;
    }
    if (!data.scopes) {
      data.scopes = [CONSTANTS.USER_SCOPES.USER];
    }

    api
      .getUserProfile(apiLevel, data)
      .then((response) => {
        const initialUserProfileRequest =
          payload && payload.initialUserProfileRequest
            ? payload.initialUserProfileRequest
            : false;
        handleProfileResponse(context, response, initialUserProfileRequest);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      });
  });

const getUserProfileForCollison = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    const data = payload;
    delete data.initialUserProfileRequest;
    if (!data.scopes) {
      data.scopes = ['user'];
    }
    api
      .getUserProfile(apiLevel, data)
      .then((response) => {
        const initialUserProfileRequest =
          payload && payload.initialUserProfileRequest
            ? payload.initialUserProfileRequest
            : false;
        context.commit('SET_USER_AFTER_COLLISION', response.user);
        handleProfileResponse(context, response, initialUserProfileRequest);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      });
  });

const getPushNotificationSetup = context =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .getPushNotificationSetup(apiLevel)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

const updatePushNotificationSetup = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .updatePushNotificationSetup(apiLevel, data)
      .then((response) => {
        context.commit('SET_PUSH_NOTIFICATION', response);
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const profileUpdate = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    const { noLanguageChange } = data;
    const updatedData = {
      ...data,
    };

    if (!data.learned_language_id) {
      const selectedLearnedLanguage =
        store.getters['settings/getSelectedLearnedLanguage'];
      updatedData.learned_language_id = selectedLearnedLanguage;
    }

    api
      .profileUpdate(apiLevel, updatedData)
      .then((response) => {
        // if (!noLanguageChange) {
        //   context.commit(
        //     'settings/SET_USER_SELECTED_LANGUAGE',
        //     fromShortToLong[response.user.languageCode],
        //     { root: true },
        //   );
        // }

        handleProfileResponse(context, response, noLanguageChange);

        // context.commit(
        //   'settings/SET_SELECTED_LEARNED_LANGUAGE',
        //   response.user.learnedLanguageCode,
        //   { root: true },
        // );
        // context.commit('SET_USER_PROFILE', response);
        // context.commit('sales/SET_SALES_FLOW', response.user.state.promotion, {
        //   root: true,
        // });
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const authWithDKTSSO = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .authWithDKTSSO(apiLevel, data)
      .then((response) => {
        if (response.errors && response.errors.length > 0) {
          const code = response.errors[0].code;
          const message = response.errors[0].message;
          reject({ code, message });
          return;
        }
        if (data.overwriteUser) {
          context.commit('storeToken', response.token, { root: true });
          context.commit('SET_PROFILE_USER', response);
        }
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const authZeroPassword = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .authZeroPassword(apiLevel, data)
      .then((response) => {
        if (response.errors && response.errors.length > 0) {
          const code = response.errors[0].code;
          const message = response.errors[0].message;
          reject({ code, message });
          return;
        }
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error("error", error);
        reject(error);
      });
  });

const authKHPoll = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .authKHPoll(apiLevel, data)
      .then((response) => {
        if (response.errors && response.errors.length > 0) {
          const code = response.errors[0].code;
          const message = response.errors[0].message;
          reject({ code, message });
          return;
        }
        context.commit('storeToken', response.token, { root: true });
        context.commit('SET_PROFILE_USER', response);
        window.$cookies.set('logged-in', true, null, null, '.xeropan.com');
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error("error", error);
        reject(error);
      });
  });

const neptunAuthKHPoll = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .authKHPoll(apiLevel, data)
      .then((response) => {
        if (response.errors && response.errors.length > 0) {
          const code = response.errors[0].code;
          const message = response.errors[0].message;
          reject({ code, message });
          return;
        }
        if (data.saveUser) {
          context.commit('storeToken', response.token, { root: true });
          context.commit('SET_PROFILE_USER', response);
          window.$cookies.set('logged-in', true, null, null, '.xeropan.com');
        }
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error("error", error);
        reject(error);
      });
  });

const neptunAuthZeroPassword = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .neptunAuthZeroPassword(apiLevel, data)
      .then((response) => {
        if (response.errors && response.errors.length > 0) {
          const code = response.errors[0].code;
          const message = response.errors[0].message;
          reject({ code, message });
          return;
        }
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error("error", error);
        reject(error);
      });
  });

const loginUser = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    const credentials = data.credentials == undefined ? data : data.credentials;
    const authTokenRequired =
      data.authTokenRequired == undefined ? undefined : data.authTokenRequired;
    api
      .loginUser(apiLevel, { credentials, authTokenRequired })
      .then((response) => {
        if (response.errors && response.errors.length > 0) {
          const code = response.errors[0].code;
          const message = response.errors[0].message;
          reject({ code, message });
          return;
        }
        context.commit('storeToken', response.token, { root: true });
        // context.commit('SET_USER_PROFILE', { user: response });

        let profilePromise;
        let needUpdate = true;
        if (
          data.defaultSettings &&
          data.defaultSettings.dontNeedProfileUpdate
        ) {
          needUpdate = false;
        }
        if (data.defaultSettings != undefined && needUpdate) {
          profileUpdate(context, data.defaultSettings).then(() => {
            profilePromise = getUserProfile(context, {
              initialUserProfileRequest: true,
              scopes: [
                CONSTANTS.USER_SCOPES.USER,
                CONSTANTS.USER_SCOPES.LEAGUE,
              ],
            });
          });
        } else if (!response.userLevel && needUpdate) {
          profileUpdate(context, { user_level: 0 }).then(() => {
            profilePromise = getUserProfile(context, {
              initialUserProfileRequest: true,
            });
          });
        } else {
          // profilePromise = getUserProfile(context, {
          //   initialUserProfileRequest: true,
          //   scopes: [CONSTANTS.USER_SCOPES.USER, CONSTANTS.USER_SCOPES.LEAGUE],
          // });
        }
        resolve({ response, profilePromise });
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getIslandProgressionList = context =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchIslandProgressionList(apiLevel)
      .then((response) => {
        context.commit('ISLAND_PROGRESSION_LIST', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getIslandProgressionItem = (context, level) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchIslandProgressionItem(apiLevel, level)
      .then((response) => {
        context.commit('ISLAND_PROGRESSION_ITEM', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getUserCountry = context =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchUserCountry(apiLevel)
      .then((response) => {
        context.commit('USER_COUNTRY', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
        console.error(error);
      });
  });

const setAvatar = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .setAvatar(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const addToFriend = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .addAsFriend(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const fetchArchivedLeagues = (context, page) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchArchivedLeagues(apiLevel, page)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const fetchClassroomLeagues = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchArchivedLeagues(apiLevel, payload.page, payload.leagueCode)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getUserProfileNotifications = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchUserProfileNotifications(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getFriendListByType = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchFriendListByType(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const collectFriends = context =>
  new Promise((resolve) => {
    const friendList = {
      google: undefined,
      facebook: undefined,
      maybe_known: undefined,
    };
    Promise.all([
      getFriendListByType(context, 'facebook'),
      getFriendListByType(context, 'google'),
      getFriendListByType(context, 'maybe'),
    ]).then((res) => {
      friendList.facebook = res[0];
      friendList.google = res[1];
      friendList.maybe_known = res[2];
      context.commit('SET_USER_FRIEND_LISTS', friendList);
      resolve(friendList);
    });
    // getFriendListByType(context, 'facebook').then((resFb) => {
    //   friendList.facebook = resFb;
    //   getFriendListByType(context, 'google').then((resGoogle) => {
    //     friendList.google = resGoogle;
    //     getFriendListByType(context, 'maybe').then((resMaybe) => {
    //       friendList.maybe_known = resMaybe;
    //       context.commit('SET_USER_FRIEND_LISTS', friendList);
    //       resolve(friendList);
    //     });
    //   });
    // });
  });

const fetchMaybeUnknownList = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchMaybeUnknownList(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const collectFriendsForInvitation = (context, userIds) =>
  new Promise((resolve) => {
    const friendList = {
      google: undefined,
      facebook: undefined,
      maybe_known: undefined,
    };
    getFriendListByType(context, 'facebook').then((resFb) => {
      friendList.facebook = resFb;
      getFriendListByType(context, 'google').then((resGoogle) => {
        friendList.google = resGoogle;
        fetchMaybeUnknownList(context, userIds).then((resMaybe) => {
          friendList.maybe_known = resMaybe;
          context.commit('SET_USER_FRIEND_LISTS', friendList);
          resolve(friendList);
        });
      });
    });
  });

const getFriendProfile = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchFriendProfile(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const profileDestroy = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .profileDestroy(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

function logoutFromKreta() {
  if (location.hostname != 'localhost') {
    fetch(
      `${process.env.VUE_APP_IDP_AUTH_CONFIG_URL}/.well-known/openid-configuration`,
    ).then(async (response) => {
      const res = await response.json();
      if (res.end_session_endpoint) {
        const a = document.createElement('a');
        a.href = res.end_session_endpoint;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    });
  }
}

const logout = (context, obj) =>
  new Promise((resolve, reject) => {
    // if (store.getters['users/isKretaUser']) {
    //   logoutFromKreta();
    // }
    if (obj) {
      // we won't clear device info only for traveller to future timetraveller login
      if (store.getters['users/getUserSocialState'] != 'traveller') {
        context.commit('device/DESTROY', undefined, { root: true });
      }
      if (store.getters['users/isKHUser'] && !location.href.includes('dkt')) {
        window.$cookies.set('logged-out', true, null, null, '.xeropan.com');
        window.$cookies.set('logged-in', false, null, null, '.xeropan.com');
      }
      context.commit('users/DESTROY', undefined, { root: true });
      store.commit('storeToken', undefined);
      store.commit('removeXTokenFromCookie');
      store.commit('storeUserStatus', undefined);
      store.commit('removeApiTokenFromCookie');
      resolve(true);
      context.commit('contents/DESTROY', undefined, { root: true });
      context.commit('settings/DESTROY', undefined, { root: true });
      context.commit('subscriptions/DESTROY', undefined, { root: true });
      context.commit('sales/DESTROY', {}, { root: true });
      context.commit('classroom/DESTROY', undefined, { root: true });
      EventBus.clearPresisUsageDataInterval();
    } else {
      reject(true);
    }
  });

const unSubscribe = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .unSubscribe(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const storeUserAction = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .storeUserAction(apiLevel, payload)
      .then((response) => {
        if (response.errors === undefined) {
          // context.commit('SET_PROFILE_USER', response);
          if (response.currentIsland != undefined) {
            const currLevel = response.currentIsland;
            const islandData = {
              level: currLevel,
              island: `island_${currLevel}`,
            };
            context.commit('contents/CURRENTLY_LOADED_ISLAND', islandData, {
              root: true,
            });
          }

          if (response.state && response.state.promotion !== undefined) {
            context.commit('sales/SET_SALES_FLOW', response.state.promotion, {
              root: true,
            });
          }
          resolve(response);
        }
        reject({ code: 400 });
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getIslandNotification = (context, payload) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchIslandNotification(apiLevel, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getCeoMessages = context =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchCeoMessage(apiLevel)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const updateCeoMessageStatus = (context, messageId) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .updateCeoMessageStatus(apiLevel, messageId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getUserInfoByInvitationCode = (context, code) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .getUserInfoByInvitationCode(apiLevel, code)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const storeWebPushInfo = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .storeWebPushInfo(apiLevel, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

const uploadContacts = (context, params) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .uploadContacts(apiLevel, params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const fetchGoogleContacts = (context, authCode) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .fetchGoogleContacts(apiLevel, authCode)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const changedPushNotificationStatus = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .changedPushNotificationStatus(apiLevel, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateClassroomName = (context, body) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .updateClassroomName(apiLevel, body)
      .then((response) => {
        context.commit('SET_USER_PROFILE', { profile: response });
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const syncTimer = (context, data) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .syncTimer(apiLevel, data)
      .then((response) => {
        context.commit('SAVE_TIMER', response.lessonTimerStatistics);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const logoutBackend = () =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .logoutUser(apiLevel)
      .then((response) => {
        store.commit('removeApiTokenFromCookie');
        store.commit('removeXTokenFromCookie');
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

const keepUserSignedIn = () =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .keepSignInUser(apiLevel)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

const updateEmailForSubscription = (context, email) =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    const requestBody = { email };
    api
      .updateEmailForSubscription(apiLevel, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const setUserAfterCollision = (context, user) => {
  context.commit('SET_USER_AFTER_COLLISION', user);
};

const setIdpToken = (context, token) => {
  context.commit('SET_IDP_TOKEN', token);
};

const getAllFriends = context =>
  new Promise((resolve, reject) => {
    const apiLevel = 1;
    api
      .getAllFriends(apiLevel)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const setProfileFromPollResponse = (context, payload) =>
  new Promise((resolve, reject) => {
    handleProfileResponse(context, payload, false);
    resolve(payload);
  });

export default {
  loginUser,
  authWithDKTSSO,
  profileUpdate,
  getUserProfile,
  getUserProfileForCollison,
  getIslandProgressionList,
  getIslandProgressionItem,
  getUserCountry,
  setAvatar,
  fetchArchivedLeagues,
  getUserProfileNotifications,
  getFriendListByType,
  getFriendProfile,
  addToFriend,
  profileDestroy,
  logout,
  unSubscribe,
  storeUserAction,
  getIslandNotification,
  collectFriends,
  getUserInfoByInvitationCode,
  uploadContacts,
  fetchGoogleContacts,
  redeemCoupon,
  getPushNotificationSetup,
  updatePushNotificationSetup,
  storeWebPushInfo,
  getCeoMessages,
  updateCeoMessageStatus,
  changedPushNotificationStatus,
  collectFriendsForInvitation,
  fetchClassroomLeagues,
  updateClassroomName,
  syncTimer,
  logoutBackend,
  keepUserSignedIn,
  updateEmailForSubscription,
  setUserAfterCollision,
  getAllFriends,
  authZeroPassword,
  authKHPoll,
  setIdpToken,
  neptunAuthZeroPassword,
  neptunAuthKHPoll,
  setProfileFromPollResponse,
};
